<div style="margin-bottom: 1%">
  <app-chartjs [data]="chartData" [id]="shownId"></app-chartjs>
</div>
